"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _IconField = _interopRequireDefault(require("../../../../IconField"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function LinkFields(_ref) {
  var isEnglish = _ref.isEnglish,
    isSpanish = _ref.isSpanish,
    renderAdvancedOptions = _ref.renderAdvancedOptions,
    subFormikBag = _ref.subFormikBag;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-7"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "url"
  }, function (fieldProps) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      label: "URL"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: 'text-primary ' + _style["default"].helpBlock
    }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("i", null, "Must start with https://"))));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "iconEn",
    component: _IconField["default"],
    label: "Icon (En)",
    disabled: !isEnglish
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "iconEs",
    component: _IconField["default"],
    label: "Icon (Es)",
    disabled: !isSpanish
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEn"
  }, function (fieldProps) {
    return isEnglish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
      label: "Display Text (En)",
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Display Text (En)"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-lg-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "headingEs"
  }, function (fieldProps) {
    return isSpanish ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdWysiwyg, _extends({}, fieldProps, {
      label: "Display Text (Es)",
      type: "input"
    })) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdInput, _extends({}, fieldProps, {
      disabled: true,
      label: "Display Text (Es)"
    }));
  }))), renderAdvancedOptions(subFormikBag));
}
var _default = exports["default"] = LinkFields;